import { useMarkerContext } from 'features/pointClouds'
import React, { useCallback, useState } from 'react'
import styled from 'styled-components'

const WAILAContainer = styled.div<{ $isVisible: boolean; $isHovered: boolean }>`
  position: absolute;
  top: -15px;
  left: 50%;
  width: 400px;
  max-width: 95vw;
  padding: 16px 20px;
  background-color: ${({ theme }) => theme.forecast.background2};
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  color: white;
  pointer-events: auto;
  z-index: 1001;

  opacity: ${({ $isVisible, $isHovered }) => {
    if (!$isVisible) return 0
    if ($isHovered) return 1
    return 0.95
  }};

  transform: ${({ $isVisible }) =>
    $isVisible
      ? 'translateX(-50%) translateY(0) scale(1)'
      : 'translateX(-50%) translateY(-10px) scale(0.98)'};

  transition:
    opacity 300ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 300ms cubic-bezier(0.4, 0, 0.2, 1);

  ${({ $isVisible }) =>
    !$isVisible &&
    `
    pointer-events: none;
  `}
`

interface WhatAmILookingAtProps {
  children: React.ReactNode
}

export const WhatAmILookingAt: React.FC<WhatAmILookingAtProps> = ({
  children,
}) => {
  const { handleTooltipEnter, startTooltipHideTimer, activeTooltipId } =
    useMarkerContext()

  const [isHovered, setIsHovered] = useState(false)

  const handleMouseEnter = useCallback(() => {
    setIsHovered(true)
    handleTooltipEnter()
  }, [handleTooltipEnter])

  const handleMouseLeave = useCallback(() => {
    setIsHovered(false)
    startTooltipHideTimer()
  }, [startTooltipHideTimer])

  const isVisible = !!activeTooltipId

  return (
    <WAILAContainer
      $isVisible={isVisible}
      $isHovered={isHovered}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}>
      {children}
    </WAILAContainer>
  )
}
